import type { App } from "vue";

import router from "@/router";
import { setupAuthGuard } from "@/router/guards/auth.guard";
import { setupProgressGuard } from "@/router/guards/progress.guard";

export default function (app: App) {
  setupAuthGuard(router);
  setupProgressGuard(router);

  app.use(router);
}
